<template>
  <div class="block-wrapper">
    <div class="data-storage-config form">
      <a-row type="flex" align="middle" :gutter="10">
        <a-col flex="2">Глубина хранения первичных данных</a-col>
        <a-col flex="3">
          <a-select v-model="data.primary_data_storage_depth" size="large" @change="emitInput">
            <template v-for="depthValue in depthValues">
              <a-select-option :key="depthValue.value" :value="depthValue.value">
                {{ depthValue.title }}
              </a-select-option>
            </template>
          </a-select>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle" :gutter="10">
        <a-col flex="2">Удалять данные</a-col>
        <a-col flex="3">
          <a-checkbox
            v-model="data.primary_data_storage_delete"
            @change="emitInput"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
const depthValues = Object.freeze([
  { value: 1, title: '1 месяц' },
  { value: 3, title: '3 месяца' },
  { value: 6, title: '6 месяцев' },
  { value: 12, title: '12 месяцев' },
]);

export default {
  name: 'DataStoringConfig',

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    depthValues,
    data: {
      primary_data_storage_depth: 1,
      primary_data_storage_delete: false
    },
  }),

  watch: {
    value() {
      this.initData();
    },
  },

  mounted() {
    this.initData();
    this.emitInput();
  },

  methods: {
    initData() {
      this.data = {
        ...this.data,
        ...this.value,
      };
    },

    emitInput() {
      this.$emit('input', this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.data-storage-config {
  max-width: 500px;
}
</style>
